import React, { useState } from 'react';
import SpaceCard from 'components/SpaceCard';
import { ClipLoader } from 'react-spinners';

const SpaceCardCarousel = ({ spaces }) => {
  const [chunkIndex, setChunkIndex] = useState(0);
  const cardsPerChunk = 3;

  if (!spaces) {
    return (
      <div className="flex justify-center items-center h-[200px]">
        <ClipLoader color="#FFBD59" size={40} />
      </div>
    );
  }

  if (spaces.length === 0) {
    return (
      <div className="flex justify-center items-center h-[200px] text-gray-500">
        No spaces available for this event.
      </div>
    );
  }

  const numberOfChunks = Math.ceil(spaces.length / cardsPerChunk);

  const nextChunk = () => {
    setChunkIndex((prevIndex) => Math.min(prevIndex + 1, numberOfChunks - 1));
  };

  const prevChunk = () => {
    setChunkIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  const visibleSpaces = spaces.slice(
    chunkIndex * cardsPerChunk,
    (chunkIndex + 1) * cardsPerChunk
  );

  return (
    <div className="flex flex-col w-full">
      {/* Controls */}
      <div className="flex justify-end mb-2">
        <button
          onClick={prevChunk}
          className={`px-4 py-2 rounded-3xl text-xl ml-2 ${
            chunkIndex === 0 ? 'bg-gray-200 text-gray-400' : 'bg-white'
          }`}
          disabled={chunkIndex === 0}
        >
          {'<'}
        </button>
        <button
          onClick={nextChunk}
          className={`px-4 py-2 rounded-3xl text-xl ml-2 ${
            chunkIndex === numberOfChunks - 1
              ? 'bg-gray-200 text-gray-400'
              : 'bg-white'
          }`}
          disabled={chunkIndex === numberOfChunks - 1}
        >
          {'>'}
        </button>
      </div>

      {/* Cards row - responsive wrapping */}
      <div className="flex flex-wrap gap-6 justify-center sm:justify-start">
        {visibleSpaces.map((space) => (
          <SpaceCard key={space.id} space={space} hideDescription />
        ))}
      </div>
    </div>
  );
};

export default SpaceCardCarousel;
